import { PubNubChatSessionDeletedMessageEvent } from 'core_main/pubnub/types';
import { runListenersForEvent } from 'core_main/globals/events';
import { ON_CONVERSATION_DELETED_EVENT_TYPE } from 'core/constants';

export const handleChatSessionDeletedEvent = (
  message: PubNubChatSessionDeletedMessageEvent,
) => {
  const { id } = message.data;
  const callbackResponse = {
    conversationId: id,
  };

  runListenersForEvent(ON_CONVERSATION_DELETED_EVENT_TYPE, callbackResponse);
};
